<template>
    <div :class="isError ? 'text-danger' : 'text-success'">
        {{ updateTokenResult }}
    </div>
</template>

<script>
import { services } from "../services/services";

const appName = 'fitbit';

export default {
    data() {
        return {
            updateTokenResult: null,
            isError: false
        };
    },
    mounted() {
        let code = new URL(location.href).searchParams.get('code');
        services.updateOauthToken(code, appName)
            .then((response) => {
                this.isError = false;
                this.updateTokenResult = response.body
            }).catch((response) => {
                this.isError = true;
                this.updateTokenResult = response.body
            });
    }
}
</script>